import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IconMenuItems = styled(MenuItem)(({theme, active}) => ({
  display: 'flex',
  backgroundColor: active === 'true' ? `${theme.iconMenuItem.backgroundActive} !important` : theme.iconMenuItem.background, 
  justifyContent: 'center',
  alignItems: 'center', 
  marginX: '0.2em', 
  height: '4em',
  width: '4em',
  borderRadius: '50%', 
  fontWeight: 'bold', 
  fontSize: '0.8em',
  border: active === 'true' ? '0.3em solid': 'none',
  '&:hover': {
    border: '0.1em solid',
    borderColor: theme.iconMenuItem.border,
    backgroundColor: theme.palette.common.hover
  },
  '&:focus-visible': {
    border: '0.1em solid',
    borderColor: theme.iconMenuItem.border,
    backgroundColor: theme.palette.common.hover
  },
}));

export const TextMenuItem = styled(MenuItem)(({theme, active}) => ({
  wordBreak: 'break-word',
  whiteSpace: 'unset',
  color: active === 'true' ? theme.textMenuItem.colorActive : theme.textMenuItem.color, 
  backgroundColor: active === 'true' ? `${theme.textMenuItem.backgroundActive} !important` : theme.textMenuItem.background, 
  marginX: '0.2em', 
  borderRadius: '0.5em', 
  fontWeight: 'bold', 
  fontSize: '0.8em',
  '&:hover': {
    backgroundColor: theme.palette.common.hover
  },
  '&:focus-visible': {
    backgroundColor: theme.palette.common.hover
  }
}));
